import React from 'react'
import { AccordionContainer } from '../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../common/components/form/input/containers/input.container';



export default function LayoutBasicInfoComponent ({handleInnerFormChange, selectedRoute,pages,websites}: any) {

  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
           <InputContainer
              label="Layout Name"
              name="LayoutName"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'LayoutName',

                )
              }}
              type="text"
              value={selectedRoute?.LayoutName}
          />
          <InputContainer
            label="Page Name"
            labelField="PageName"
            list={pages}
            onValueChange={(event: any) => {
                handleInnerFormChange(
                event.target.value,
                'PlatformWebSitePageId'
                
              );
            }}
     optionName='Choose Page'
            type="select"
            value={selectedRoute?.PlatformWebSitePageId}
            valueField="Id"
        />
          <InputContainer
            label="WebSite Name"
            labelField="WebsiteName"
            list={websites}
            onValueChange={(event: any) => {
                handleInnerFormChange(
                event.target.value,
                'PlatformWebSiteId'
                
              );
            }}
     optionName='Choose Website'
            type="select"
            value={selectedRoute?.PlatformWebSiteId}
            valueField="Id"
        />
        <InputContainer

label="Remarks"
name="Remarks"
onValueChange={(event: any) => {
  handleInnerFormChange(
    event.target.value,
     'Remarks',

       )
     }}
 type="text"
 value={selectedRoute?.Remarks}
/>
     </div>
  }
    expandedPanel="userInfo"
    headerTitle="Basic Info"
/>

        </>
  )
}